
/**
 * Internal server error
 */
export type InternalServerErrorResponse = void;
